import PropTypes from 'prop-types';
import React from 'react';
import Highlighter from '../highlighter';
import contentStateToString from '../../services/content-state-to-string';
import styles from './simple-renderer.scss';

const Renderer = ({ contentState, query }) => {
  const content = contentStateToString(contentState);
  return (
    <div className={styles.content}>
      {query ? <Highlighter text={content} query={query}/> : content}
    </div>
  );
};

Renderer.propTypes = {
  type: PropTypes.string,
  contentState: PropTypes.object,
  query: PropTypes.string,
};

export default Renderer;



// WEBPACK FOOTER //
// ./app/components/simple-renderer/simple-renderer.js